export const domainHelper = () => {
  if (window.env && window.env.ENVIRONMENT === 'production') {
    return 'com'
  }
  return 'cc'
}



// WEBPACK FOOTER //
// ./src/helpers/domainHelper.ts